// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2G76X","content":"styles_content__LlDib","checkbox":"styles_checkbox__3CdtL","checkboxLabel":"styles_checkboxLabel__2ri5D"};